import { useAuth0 } from '@auth0/auth0-react';

const LoginButton = () => {
    const { loginWithRedirect, isAuthenticated } = useAuth0();

    return (
        !isAuthenticated && (
            <button className="get-started" onClick={() => loginWithRedirect()}>Let's Scream</button>
        )
    )
}

export default LoginButton